import { useRouter } from 'vue-router';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f623f96e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "com-table"
};
const _hoisted_2 = {
  class: "com-table-operation"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "com-title"
}, "详情-对账明细", -1));
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  key: 3
};
const _hoisted_8 = {
  key: 4
};
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { columnsThird } from '../data';
import { usePagination } from '@/hooks/usePagination';
import { useRoute } from 'vue-router';
import { queryBillDetailList } from '@/api/billBoardApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailTable',
  setup(__props) {
    const dataSource = ref([]);
    const loading = ref(false);
    const {
      pageTotal,
      pageIndex,
      pageSize,
      currentPageSizeChange
    } = usePagination(() => {
      initTableData();
    });
    const myRoute = useRoute();
    const myRouter = useRouter();
    const scrollY = ref(300);
    // 订单类型值过滤
    const getPayStatusText = computed(() => value => {
      return value == 20 ? '付款' : '退款';
    });
    const initTableData = async () => {
      try {
        loading.value = true;
        const params = {
          aggregateId: myRoute.query.aggregateId,
          pageSize: pageSize.value,
          pageNum: pageIndex.value
        };
        const {
          code,
          data
        } = await queryBillDetailList(params);
        if (code == '0') {
          dataSource.value = data.list;
          pageTotal.value = data.total;
        }
        loading.value = false;
      } catch (e) {}
    };
    // 动态更新 scrollY，比如根据窗口高度调整
    const updateScrollY = () => {
      const height = window.innerHeight; // 假设预留一些空间
      scrollY.value = height - 24 - 54 - 32 - 90 - 48 - 48 - 60;
    };
    onMounted(() => {
      updateScrollY();
      window.addEventListener('resize', updateScrollY);
      initTableData();
    });
    onUnmounted(() => {
      window.removeEventListener('resize', updateScrollY);
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = () => {
          _unref(myRouter).back();
        })
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回 ")]),
        _: 1
      }), _hoisted_3]), _createVNode(_component_a_table, {
        columns: _unref(columnsThird),
        "data-source": dataSource.value,
        scroll: {
          y: scrollY.value
        },
        loading: loading.value,
        bordered: "",
        pagination: false
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'diffAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(`${record.diffAmount}(${record === null || record === void 0 ? void 0 : record.diffRateAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffRevenue' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`${record.diffRevenue}(${record === null || record === void 0 ? void 0 : record.diffRateRevenue})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffOrderAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${record.diffOrderAmount}(${record === null || record === void 0 ? void 0 : record.diffRateOrderAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffRefundOrderAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(`${record.diffRefundOrderAmount}(${record === null || record === void 0 ? void 0 : record.diffRateRefundOrderAmount})`), 1)) : _createCommentVNode("", true), column.dataIndex === 'diffRateRefundAmount' ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(`${record.diffRefundAmount}(${record === null || record === void 0 ? void 0 : record.diffRateRefundAmount})`), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "loading"]), _createVNode(_component_a_pagination, {
        class: "com-table-pagination",
        total: _unref(pageTotal),
        "show-total": total => `共 ${total} 条`,
        current: _unref(pageIndex),
        "onUpdate:current": _cache[1] || (_cache[1] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        "show-size-changer": "",
        "page-size": _unref(pageSize),
        "onUpdate:page-size": _cache[2] || (_cache[2] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        onChange: _unref(currentPageSizeChange)
      }, null, 8, ["total", "show-total", "current", "page-size", "onChange"])]);
    };
  }
});